import React, {useEffect, useState, useRef} from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge, Table, Modal,UncontrolledCarousel,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from 'reactstrap';

import {customStyles} from '../../../helpers/mycomps'
import Select from "react-select";
import {fieldvalidator, filenamevalid,bannernamevalid, alphanum, alpha, numtests, numdtest,
  floattest, numtest} from '../../../helpers/validate'
  
  import ReactDatetime from "react-datepicker";
  import "react-datepicker/dist/react-datepicker.css";
import { fill } from "lodash";

function Banners(props) {
  const [b1list, setB1list] = useState([])
  const [b1s, setB1s] = useState({category : "", image : "", btype : "", uDate : "", uBy : "", buid : "" , isEnabled : "", expirey : "", url:""})
  const [showProcessing , setShowProcessing] = useState(false)
  const [btypelist , setBtypelist] = useState([{value : 0, label : "Cars"}, {value : 1, label : "Yacht"}, {value : 2, label : "Machine"}])
  const [selectedBtype, setSelectedBtype] = useState({})
  const hiddenFileInput = useRef(null);
  const [showModal, setShowModal] = useState(false)
  const [expModal, setExpModal] = useState(false)
  const [enModal, setEnModal] = useState(false)
  const [{alt, src}, setImg] = useState({
    src: "",
    alt: ''
  });
  const [filenames, setFilenames] = useState()
  
  const [showi, setShowi] = useState(false)
  
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex2, setActiveIndex2] = useState(0);
  const [animating, setAnimating] = useState(false);

useEffect(() => {
  fbanner()
},[])
// fetch currency for update 
const fbanner = () => {
  setShowProcessing(true)
  props.API.get(`tenant/getbanner`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
  
      setShowProcessing(false)

      setB1list(res.data.data.map((tt, key) => {
      
        return tt
      }))
    }).catch(function (error) {
      setShowProcessing(false)
      if(error.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }
      //props.swal("Error fetching currency data")
    }) 
}

const b1listshow = () => {
   
      return (
          <><Table>
              <thead>
                <tr>
                  <th></th>
                  <th>ID</th>
                  <th>B-</th>
                  <th>File</th>
                  <th>Expiry</th>
                  <th>Updated</th>
                  <th>Active</th>
                  <th>By</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                    b1list.filter((b) => b.btype === "B-1" && b.category === selectedBtype.label).map((x, key) => {
                      
                    return (
                      <tr key={key}>
                        <td><i className="fa fa-eye" aria-hidden="true" onClick={u => {
                      setShowi(!showi); setB1s(x)
                    }}></i></td>
                        <td>{x.buid}</td>
                        <td>{x.btype}</td>
                        <td>{x.image !== "" ? x.image : x.fallback}</td>
                        <td> <i className="fa fa-exclamation-triangle" aria-hidden="true" onClick={g => {setExpModal(true); setB1s(x)}}></i> {new Date(x.expirey).toDateString('GB')}</td>
                        <td>{new Date(x.uDate).toDateString('GB')}</td>
                        <td><i className="fa fa-pencil-square-o" aria-hidden="true" onClick={y => {setEnModal(!enModal); setB1s(x)}}></i>{x.isEnabled ? " YES" : " NO"}</td>
                        <td>{x.uBy}</td>
                        <td>
                        <i className="fa fa-cloud-upload" aria-hidden="true"  onClick={e => {
                                handleClick(e)
                                setB1s(x)
                              }}></i>
                        </td>
                      </tr>
                    )
                    })
                }
              </tbody>
            </Table> </>
      )

}

const b2listshow = () => {
   
  return (
      <><Table>
          <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>B-</th>
              <th>File</th>
              <th>Expiry</th>
              <th>Updated</th>
              <th>Active</th>
              <th>By</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
                b1list.filter(b => b.btype === "B-2" && b.category === selectedBtype.label).map((x, key) => {
                
                return (
                  <tr key={key}>
                    <td><i className="fa fa-eye" aria-hidden="true" onClick={u => {
                      setShowi(!showi); setB1s(x)
                    }}></i></td>
                    <td>{x.buid}</td>
                    <td>{x.btype}</td>
                    <td>{x.image !== "" ? x.image : x.fallback}</td>
                        <td> <i className="fa fa-exclamation-triangle" aria-hidden="true"  onClick={g => {setExpModal(true); setB1s(x)}}></i> {new Date(x.expirey).toDateString('GB')}</td>
                        <td>{new Date(x.uDate).toDateString('GB')}</td>
                    <td><i className="fa fa-pencil-square-o" aria-hidden="true" onClick={y => {setEnModal(!enModal);setB1s(x)}}></i>{x.isEnabled ? " YES" : " NO"}</td>
                    <td>{x.uBy}</td>
                    <td><i className="fa fa-cloud-upload" aria-hidden="true"  onClick={e => {
                                handleClick(e)
                                setB1s(x)
                              }}></i></td>
                  </tr>
                )
                })
            }
          </tbody>
        </Table> </>
  )

}
  // const [b1, setB1] = useState([])
  // const [b2, setB2] = useState([])
  // const [b3, setB3] = useState([])
  const handleImg = (e) => {
    
    if(e.target.files[0]) {
            
        if(bannernamevalid(e.target.files[0])){
          setFilenames(e.target.files[0])
          setImg({
            src: URL.createObjectURL(e.target.files[0]),
            alt: e.target.files[0].name
        });
        setShowModal(true)
        }else{
          props.swal("Invalid Filename")
        }
        
    
    }   
}

const handleClick = event => {
  hiddenFileInput.current.click();
};


const submitBanner = () => {
  let formData = new FormData(); 
  formData.append("banner" , filenames)
  formData.append("B1s", JSON.stringify(b1s) );
  setShowProcessing(true)
  props.API({
    method: "post",
    url : `tenant/updbanner`,
    data: formData,
    headers : {"arixauth" : localStorage.getItem("arixauth")}
    }).then((res) => {
      props.swal("Banner Created, Please refresh page to view updated.")
      setShowProcessing(false)
      setB1list(res.data.data.map((tt, key) => {
        return tt
      }))
      setShowModal(false)
    }).catch(function (error) {
      setShowProcessing(false)
    //  console.log(error.response)
    if(error.response.status === 401){
      props.swal("Unauthorized, please login again.").then(t => {
          props.history.push(`/auth/login`)
      })   
    }else{
      props.swal(error.response.data.message)
    }
     
     
}) 
}

const submitExp = () => {
  setShowProcessing(true)
  props.API.post(`tenant/updbannerexp`,{b1s}, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      props.swal(res.data.message)
      setShowProcessing(false)
      setB1list(res.data.data.map((tt, key) => {
      
        return tt
      }))
      setExpModal(false)
      setEnModal(false)
    }).catch(function (error) {
      setShowProcessing(false)
    //  console.log(error.response)
   
      if(error.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }else{
        props.swal(error.response.data.message)
      }
}) 
}

const changEexpiry = () => {
  return(
<Modal isOpen={expModal}>
  <ModalHeader toggle={() => setExpModal(!expModal)}>
    {b1s.buid} {' '}, {b1s.btype} , {b1s.image} 
  </ModalHeader>
  <ModalBody>
    <Row>
      <Col>Expiry Date <ReactDatetime dateFormat='dd/MM/yyyy' onChange={e => setB1s({...b1s, expirey : e})} value={new Date(b1s.expirey).toLocaleDateString()}/>
      <Button size="sm" style={{marginTop : 0, float : "right"}} onClick={x => submitExp()}>update</Button></Col>
      
    </Row>
    
    
  </ModalBody>
</Modal>
  )
  
}


const changeActive = () => {
  return(
<Modal isOpen={enModal}>
  <ModalHeader toggle={() => setEnModal(!enModal)}>
    {b1s.buid} {' '}, {b1s.btype} , {b1s.image}  {b1s.isEnabled === "true" ? "Active": "Disabled"} 
  </ModalHeader>
  <ModalBody>
    <p>
      <center>
      <Input type="checkbox" checked ={b1s.isEnabled} onChange={t => setB1s({...b1s, isEnabled : !b1s.isEnabled}) } /> {' '}&emsp;    <label>Enabled  </label>
      </center>
      </p>

      <center>
      <Input type="text" value ={b1s.url} onChange={t => setB1s({...b1s, url : t.target.value}) } /> {' '}&emsp; 
      </center>
    
    <p>
    <center>
    <Button size="sm" onClick={x => submitExp()}>update</Button>
    </center>
    </p>
    
    
  </ModalBody>
</Modal>
  )
  
}

const showModall = () =>{
  return (
    <Modal isOpen={showModal}>
      <ModalHeader toggle={() => setShowModal(!showModal)}>
      
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col><p>Submit this Banner ?</p> </Col>
          <Col><Button size="sm" style={{marginTop : 0, float : "right"}} onClick={x => submitBanner()}>OK</Button></Col>
          
        </Row>
        <Row>
          <Col>
          <img src={src} alt=""  style={{border : "1px solid black"}}/>
          </Col>
        </Row>
        
      </ModalBody>
    </Modal>
  )
}
//    <img src={"http://10.1.10.30:3200/banners/B-2/buid_10_logo.png"} alt=""  style={{border : "1px solid black"}}/>
const showImg = () => {
  return (
    <Modal isOpen={showi}>
      <ModalHeader toggle={() => setShowi(!showi)}>
      
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
          <img src={`${b1s.image}`} alt=""  style={{border : "1px solid black"}}/>
      
          </Col>
        </Row>
        
      </ModalBody>
    </Modal>
  )
}


const next = () => {
  if (animating) return;
  const nextIndex = activeIndex === ccitems1.length - 1 ? 0 : activeIndex + 1;
  setActiveIndex(nextIndex);
};

const previous = () => {
  if (animating) return;
  const nextIndex = activeIndex === 0 ? ccitems1.length - 1 : activeIndex - 1;
  setActiveIndex(nextIndex);
};

const goToIndex = (newIndex) => {
  if (animating) return;
  setActiveIndex(newIndex);
};

const next2 = () => {
  if (animating) return;
  const nextIndex = activeIndex2 === ccitems2.length - 1 ? 0 : activeIndex2 + 1;
  setActiveIndex2(nextIndex);
};

const previous2 = () => {
  if (animating) return;
  const nextIndex = activeIndex2 === 0 ? ccitems2.length - 1 : activeIndex2 - 1;
  setActiveIndex2(nextIndex);
};

const goToIndex2 = (newIndex) => {
  if (animating) return;
  setActiveIndex2(newIndex);
};
const ccitems1 = b1list.filter(b => b.btype === "B-1" && b.category === selectedBtype.label).map((x, key) => {
  let date = new Date()
  let imge = new Date(x.expirey) <= date ? x.fallback :x.image
  //x.image = imge
    return (
      {
        altText: x.btype,
        caption: x.category,
        key: key,
        src: `${imge}`,
      
      }
    )
    })

const ccitems2 = b1list.filter(b => b.btype === "B-2" && b.category === selectedBtype.label).map((x, key) => {
 
  let date = new Date()
  let imge = new Date(x.expirey) <= date ? x.fallback :x.image
      return (
        {
          altText: x.btype,
          caption: x.category,
          key: key,
          src: `${imge}`,
          
        }
      )
      })
  

  const slidesb1 = ccitems1.map((item) => {
        return (
          <CarouselItem
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={item.key}
            
          ><center>
            <img src={item.src} alt={item.altText} style={{width : "650px", maxWidth : "650px" , height : "200px" , maxHeight: "200px", objectFit : "fill"}}/>
            </center>
          </CarouselItem>
        );
      });      

  const slidesb2 = ccitems2.map((item) => {
        return (
          <CarouselItem
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={item.key}
            
          ><center>
            <img src={item.src} alt={item.altText} style={{width : "650px", maxWidth : "650px" , height : "200px" , maxHeight: "200px", objectFit : "fill"}}/>
            </center>
          </CarouselItem>
        );
      });    


  return (
    <div className="content">
      {showModall()}
      {changEexpiry()}
      {changeActive()}
      {showImg()}
        <input
         ref={hiddenFileInput}
         type="file" 
         accept=".png, .jpg, .jpeg" 
         id="photo" 
         className="visually-hidden"
         onChange={e=> handleImg(e)}
         hidden/>
    <Card>
    {showProcessing && props.Spin}
        <Row>
          <Col md="6">
          <Card >
            <CardHeader>
              Banner - 1
            </CardHeader>
            <CardBody>
           <Carousel
              activeIndex={activeIndex}
              next={next}
              previous={previous}
             
            >
              <CarouselIndicators
                items={ccitems1}
                activeIndex={activeIndex}
                onClickHandler={goToIndex}
              />
              {slidesb1}
              <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={previous}
              />
              <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={next}
              />
            </Carousel>
            </CardBody>
          </Card>
          
           </Col>
          <Col md="6">
          <Card>
            <CardHeader>
              Banner - 2
            </CardHeader>
            <CardBody>
                       <Carousel
              activeIndex={activeIndex2}
              next={next2}
              previous={previous2}
             
            >
              <CarouselIndicators
                items={ccitems2}
                activeIndex={activeIndex2}
                onClickHandler={goToIndex2}
              />
              {slidesb2}
              <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={previous2}
              />
              <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={next2}
              />
            </Carousel>
            </CardBody>
          </Card>
          </Col>
        </Row>
      </Card>
      <Card>
        <CardHeader><h6 onClick={x => fbanner()}>Banners</h6> <i onClick={x => fbanner()} className="fa fa-refresh" aria-hidden="true" style={{float :"right", cursor : "pointer"}}></i></CardHeader>
        <CardBody>
          <Row>
            <Col  xs="12" md="4" > 
                <Row>
                  <Col xs="12" md="2"><label style={{marginTop : 10}}>Type</label></Col>
                  <Col  xs="12" md="10">
                  <Select options={btypelist} styles={customStyles} 
                      onChange={e=> {
                        setSelectedBtype(e)
                            }} />
                  </Col>
              </Row>
            </Col>
          </Row>
          <hr />
          <Row style={{marginTop  :10}}>
              <Col>
                  Ideal Aspact Ratio : 3.25 : 1  / 650px : 200px
              </Col>
          </Row>
          <Row>
              <Col>
              {
                b1listshow()
                }
              </Col>
          </Row>

         <hr />
         <Row style={{marginTop  :10}}>
              <Col>
                  Ideal Aspact Ratio : 3.25 : 1  / 650px : 200px         
              </Col>
          </Row>
          <Row>
            <Col>
                {
                b2listshow()
                }
            </Col>
          </Row>
     
        </CardBody>
      </Card>
      
    </div>
  )

}

export default Banners;